import { Routes } from '@angular/router';
import { RepairNetwork } from './main/repair-network/repair-network';
import { SupplierNetwork } from './main/supplier-network/supplier-network';
import { GarageDetails } from './main/garage-details/garage-details';
import { RegistrationDecode } from './main/registration-decode/registration-decode';
import { Make } from './main/make/make';
import { Model } from './main/model/model';
import { Year } from './main/year/year';
import { Variant } from './main/variant/variant';
import { EstimateList } from './main/estimate-list/estimate-list';
import { EstimateDetails } from './main/estimate-details/estimate-details';
import { EstimateDetailsDownload } from './main/estimate-details-download/estimate-details-download';
import { Loading } from './main/loading/loading';

export const routes: Routes = [
    { path: '', component: RepairNetwork },
    { path: 'repair-network', component: RepairNetwork },
    { path: 'supplier-network', component: SupplierNetwork },
    { path: 'garage-details/:key', component: GarageDetails },
    { path: 'registration-decode', component: RegistrationDecode },
    { path: 'make', component: Make },
    { path: 'model', component: Model },
    { path: 'year', component: Year },
    { path: 'variant', component: Variant },
    { path: 'estimate-list', component: EstimateList },
    { path: 'estimate-details/:id/:name', component: EstimateDetails },
    { path: 'estimate-details-download', component: EstimateDetailsDownload },
    { path: 'loading', component: Loading },
];
